// extracted by mini-css-extract-plugin
export default {"wrapper":"BankIdPrompt_wrapper__mMlKA"};